import React from "react";
import { CheckCircle, AlertCircle, Activity } from "lucide-react";

const StepReviewProcess = ({
  previewData,
  selectedEmployees,
  processingPayroll,
  modalStyles,
  currentTheme,
  t,
}) => {
  return (
          <div style={modalStyles.formSection}>
            <h3 style={modalStyles.sectionTitle}>
              <CheckCircle size={20} />
              {t("reviewProcess")}
            </h3>

            {previewData && (
              <>
                <div style={modalStyles.previewCard}>
                  <h4
                    style={{
                      marginBottom: "16px",
                      color: currentTheme.colors.textPrimary,
                    }}
                  >
                    {t("payrollSummary")}
                  </h4>

                  <div style={modalStyles.formGrid}>
                    <div style={{ textAlign: "center" }}>
                      <div
                        style={{
                          fontSize: "12px",
                          color: currentTheme.colors.textSecondary,
                        }}
                      >
                        {t("employees")}
                      </div>
                      <div
                        style={{
                          fontSize: "24px",
                          fontWeight: "800",
                          color: currentTheme.colors.primary,
                        }}
                      >
                        {previewData.totalEmployees}
                      </div>
                    </div>

                    <div style={{ textAlign: "center" }}>
                      <div
                        style={{
                          fontSize: "12px",
                          color: currentTheme.colors.textSecondary,
                        }}
                      >
                        {t("grossTotal")}
                      </div>
                      <div
                        style={{
                          fontSize: "20px",
                          fontWeight: "700",
                          color: currentTheme.colors.info,
                        }}
                      >
                        {previewData.totalGross.toLocaleString()}{" "}
                        {t("currency")} {/* هتطبع جنيه هنا */}
                      </div>
                    </div>

                    <div style={{ textAlign: "center" }}>
                      <div
                        style={{
                          fontSize: "12px",
                          color: currentTheme.colors.textSecondary,
                        }}
                      >
                        {t("deductions")}
                      </div>
                      <div
                        style={{
                          fontSize: "20px",
                          fontWeight: "700",
                          color: currentTheme.colors.danger,
                        }}
                      >
                        {previewData.totalDeductions.toLocaleString()}{" "}
                        {t("currency")}
                      </div>
                    </div>

                    <div style={{ textAlign: "center" }}>
                      <div
                        style={{
                          fontSize: "12px",
                          color: currentTheme.colors.textSecondary,
                        }}
                      >
                        {t("taxInsurance")}
                      </div>
                      <div
                        style={{
                          fontSize: "16px",
                          fontWeight: "600",
                          color: currentTheme.colors.warning,
                        }}
                      >
                        {(
                          previewData.taxTotal + previewData.insuranceTotal
                        ).toLocaleString()}{" "}
                        {t("currency")}
                      </div>
                    </div>
                  </div>

                  <div style={modalStyles.previewTotal}>
                    {t("netTotal")}: {previewData.totalNet.toLocaleString()}{" "}
                    {t("currency")}
                  </div>
                </div>

                <div style={modalStyles.previewCard}>
                  <h4
                    style={{
                      marginBottom: "12px",
                      color: currentTheme.colors.textPrimary,
                    }}
                  >
                    {t("employeeBreakdown")}
                  </h4>
                  <div style={{ maxHeight: "200px", overflowY: "auto" }}>
                    {previewData.employees.map((emp, index) => (
                      <div
                        key={index}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          padding: "8px 0",
                          borderBottom: `1px solid ${currentTheme.colors.borderLight}`,
                        }}
                      >
                        <span
                          style={{ color: currentTheme.colors.textPrimary }}
                        >
                          {emp.name}
                        </span>
                        <div style={{ display: "flex", gap: "20px" }}>
                          <span
                            style={{
                              color: currentTheme.colors.info,
                              fontWeight: "600",
                            }}
                          >
                            {emp.gross.toLocaleString()} {t("currency")}
                          </span>
                          <span
                            style={{
                              color: currentTheme.colors.danger,
                              fontWeight: "600",
                            }}
                          >
                            -{emp.deductions.toLocaleString()} {t("currency")}
                          </span>
                          <span
                            style={{
                              color: currentTheme.colors.success,
                              fontWeight: "700",
                            }}
                          >
                            {emp.net.toLocaleString()} {t("currency")}
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </>
            )}

            <div
              style={{
                background: `${currentTheme.colors.warning}10`,
                padding: "16px",
                borderRadius: "8px",
                marginTop: "16px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  color: currentTheme.colors.warning,
                }}
              >
                <AlertCircle size={16} />
                <strong>{t("important")}:</strong>{" "}
                {t("processPayrollWarning").replace(
                  "{count}",
                  selectedEmployees.length,
                )}
              </div>
            </div>
          </div>
  );
};

export default StepReviewProcess;